import { SIGN_IN_ROUTE } from "_constants";
import { getAccessToken } from "_helpers";
import { Navigate } from "react-router-dom";

const OnboardingGuard = ({ children }) => {
  if (!getAccessToken()) {
    return <Navigate to={SIGN_IN_ROUTE} replace />;
  }
  return children;
};

export default OnboardingGuard;
